import { Link } from '@mui/joy';
import { ICellRendererParams } from 'ag-grid-community';

import { IPartFinderCatalogFamily } from 'partFinder/types';

import { useCatalogContext } from './CatalogContext';

// A Part Finder family opens its filter page in a drawer from here; the name opens it as a page.
export const SourceCell = ({ data, value }: ICellRendererParams<IPartFinderCatalogFamily>) => {
  const { onOpenFamily } = useCatalogContext();

  return data ? (
    <Link component="button" type="button" onClick={() => onOpenFamily(data.id)}>
      {value}
    </Link>
  ) : null;
};
